<!-- 通过后端接口，直接上传excel，进行数据导入 -->
<template>
  <div id="GjwImportFile">
    <gjw-dialog 
      :show-dialog="show"
      :title="title"
      :config="{ class: 'has-footer-border' }"
      @close="cancelUpload"
    >
      <el-upload
        ref="upload"
        class="file-uploader"
        with-credentials
        :action="url"
        :limit="limit"
        :accept="allowTypes"
        :show-file-list="false"
        :file-list="fileList"
        :auto-upload="false"
        :on-change="fileChange"
        :on-success="uploadSuccess"
        :on-error="uploadError"
      >
        <template #trigger>
          <div v-show="confirmDisable" class="upload-trigger">选取本地文件</div>
        </template>
      </el-upload>
      <template v-if="!confirmDisable">
        <div v-for="file in fileList" :key="file.uid" class="upload-file-list">
          <i class="el-icon-document mg-rt-md" />
          <span>{{ file.name }}</span>
        </div>
      </template>
      <div class="tip-content">
        <slot name="tipContent" />
      </div>
      <template #customFooter>
        <el-button @click="cancelUpload">取消</el-button>
        <el-button type="primary" :disabled="confirmDisable" @click="uploadStart">导入</el-button>
      </template>
    </gjw-dialog>
  </div>
</template>

<script>
export default {
  name: 'GjwImportFile',
  props: {
    title: {
      type: String,
      default: '上传文件'
    },
    // 上传地址
    url: String,
    // 允许上传的文件格式，如果有多个，以英文逗号相隔
    allowTypes: {
      type: String,
      default: '.xlsx'
    },
    // 单位M
    maxSize: {
      type: Number,
      default: 16
    },
    limit: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      show: false,
      fileList: [],
    }
  },
  computed: {
    confirmDisable() {
      return !this.fileList || !this.fileList.length
    }
  },
  methods: {
    showDialog() {
      this.show = true
    },
    // 检查文件
    checkFile(file) {
      const allowTypes = this.allowTypes.split(',')
      const arr = file.name.split('.')
      const type = '.' + arr[arr.length - 1].toLowerCase()
      const isType = allowTypes.indexOf(type) > -1
      const isLtMaxSize = file.size / 1024 / 1024 < this.maxSize
      if (!isType) {
        this.$message.error(`文件格式有误，请选择Excel文件`)
        return false
      }
      if (!isLtMaxSize) {
        this.$message.error(`请选择${this.maxSize}M以内的文件`)
        return false
      }
      return true
    },
    fileChange(file, fileList) {
      if (file.status === 'ready') {
        if (!this.checkFile(file)) {
          const index = fileList.findIndex((x) => { return x.uid === file.uid })
          fileList.splice(index, 1)
          return
        }
        this.fileList = fileList
      }
    },
    // 开始上传
    uploadStart() {
      this.$emit('uploading', true)
      this.$refs.upload.submit()
      // this.$fullLoading && this.$fullLoading.open()
    },
    uploadSuccess(response) {
      this.show = false
      this.$emit('uploading', false)
      this.$emit('success', response)
    },
    uploadError(err, file, fileList) {
      this.show = false
      this.$emit('uploading', false)
      this.$emit('error', { err, file, fileList })
      // this.$fullLoading && this.$fullLoading.close()
      this.$message.error('系统异常，文件上传失败')
    },
    // 取消上传
    cancelUpload() {
      // 清空已上传的文件列表
      this.$refs.upload.clearFiles()
      this.fileList = []
      this.show = false
    },
  }
}
</script>

<style lang="less" scoped>
.file-uploader {
  /deep/ .el-upload{
    display: block;
  }
}
.upload-area{
  padding: 12px 20px;
  border-radius: 4px;
  background: #F5F5FA;
}
.upload-trigger{
  .upload-area;
  color: #3264FF;
  &:hover{
    background: #E0E8FF;
  }
}
.upload-file-list{
  .upload-area;
}
.tip-content{
  color: #646469;
  margin-top: 30px;
}
</style>
